import { DesignerAttribution } from '@vp/ep-designer-attribution';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Button,
    FlexBox,
    P,
} from '@vp/swan';
import Image from 'next/image';
import styled from 'styled-components';
import { scrollToElementById } from '@99designs/browser';
import { __ } from '@99designs/i18n';
import { linkTo } from '@99designs/routing';
import heroImage from '../../images/header-image.png';
import { FeaturedProductsId } from '../FeaturedProducts/FeaturedProducts';
import { HowItWorksId } from '../HowItWorks/HowItWorks';

const ImageContainer = styled(FlexBox)`
    flex-basis: 50%;
`;

const DesignerAttributionWrapper = styled.div`
    align-self: end;
`;

export function Header() {
    return (
        <Banner backgroundColor="strong" data-testid="hero">
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow>{__('Design Services')}</BannerEyebrow>
                    <BannerTitle>{__('Let the professionals take it from here')}</BannerTitle>
                    <BannerDescription>
                        <P>
                            {__(
                                'Our community of trusted designers can create standout designs for every stage of your business journey.'
                            )}
                        </P>
                    </BannerDescription>
                    <BannerLinks>
                        <Button
                            skin="primary"
                            onClick={() => scrollToElementById(FeaturedProductsId)}
                        >
                            {__('Choose a product')}
                        </Button>
                        <Button skin="secondary" onClick={() => scrollToElementById(HowItWorksId)}>
                            {__('Learn more')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <ImageContainer flexDirection="column" justifyContent="center" alignItems="flex-start">
                <Image
                    src={heroImage}
                    alt=""
                    role="presentation"
                    quality={95}
                    style={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: '670px',
                    }}
                    priority
                />
                <DesignerAttributionWrapper>
                    <DesignerAttribution
                        designerName="OscarBastidas"
                        avatarURL={linkTo.attributionAvatar('5041158', 128)}
                    />
                </DesignerAttributionWrapper>
            </ImageContainer>
        </Banner>
    );
}
